"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEventItemErrorId = void 0;
// 존재하지 않는 이벤트, 오류가 발생했을 때를 대비하여 넣어둔다.
exports.AEventItemErrorId = -999999;
